import { Affix, Button, Space } from 'antd';

/**
 * Олон алхамт урсгалуудын алхам бүрд хуваалцаж ашиглах доод талын үйлдлийн мөр.
 * Дэлгэцийн доод хэсэгт наалдана — урт форм гүйлгэхэд ч товчнууд харагдана.
 * `extra` талбарт нийт дүн зэрэг товч мэдээллийг зүүн талд харуулна.
 *
 * Хэрэглэдэг дэлгэцүүд:
 *   - views/orderDelivery/Add (Хүргэлтийн захиалга үүсгэх)
 *   - views/orders (Татан авалтын захиалга үүсгэх)
 */
const StepFooter = ({
  onPrev,
  onSubmit,
  submitText = 'Үргэлжлүүлэх',
  htmlType = 'submit',
  loading = false,
  disabled = false,
  extra = null,
}) => (
  <Affix offsetBottom={16}>
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: 12,
        backgroundColor: '#fff',
        border: '1px solid #f1f2f4',
        borderRadius: 8,
        boxShadow: '0 1px 2px rgba(16, 22, 26, 0.04)',
      }}
    >
      <div>{extra}</div>
      <Space size={8}>
        {onPrev && <Button onClick={onPrev}>Буцах</Button>}
        <Button
          type="primary"
          htmlType={htmlType}
          loading={loading}
          disabled={disabled}
          onClick={onSubmit}
        >
          {submitText}
        </Button>
      </Space>
    </div>
  </Affix>
);

export default StepFooter;
